module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/dark/long-right-2a769952e0d0ac25b037d3c1b88f3f60.png";